import { SETTINGS_LINKS } from "../../config";

export const PAYMENT_LINKS = {
  BASE: SETTINGS_LINKS.PAYMENT,
  VIEW: `${SETTINGS_LINKS.PAYMENT}/view`,
  EDIT: `${SETTINGS_LINKS.PAYMENT}/edit`,
};